import { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PeopleChartEmployeeSidepanelBasicInfoFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  employee: PeopleChartEmployeeSidepanelBasicInfoFragment
}

const TeamsDetail: FC<Props> = ({ employee }) => {
  return (
    <Box
      background="grey100"
      borderRadius={{
        topLeft: 'abs016',
        topRight: 'abs016',
      }}
    >
      <Box padding="s32">
        <Box
          border={{
            bottom: {
              style: 'solid',
              width: 's1',
              color: 'grey400',
            },
          }}
          gap="s16"
          paddingBottom="s16"
        >
          <Text.Normal weight="bold" size="300">
            {i18n.t('people_chart.employee_detail.general_information')}
          </Text.Normal>
          <Box justifyContent="spaceBetween" flexDirection="row" gap="s8">
            <Box gap="s12">
              <Text.Normal weight="medium" size="100">
                {i18n.t('people_chart.employee_detail.manager')}
              </Text.Normal>
              <Text.Normal weight="medium" size="100">
                {i18n.t('people_chart.employee_detail.legal_entity')}
              </Text.Normal>
              <Text.Normal weight="medium" size="100">
                {i18n.t('people_chart.employee_detail.hiring_date')}
              </Text.Normal>
            </Box>
            <Box alignItems="flexEnd" gap="s12">
              <Text.Normal size="100" weight="semibold">
                {employee.manager?.fullName}
              </Text.Normal>
              <Text.Normal size="100" weight="semibold">
                {employee.legalEntity?.legalName}
              </Text.Normal>
              <Text.Normal size="100" weight="semibold">
                {employee.referenceContract?.startsOn}
              </Text.Normal>
            </Box>
          </Box>
        </Box>

        <Box
          border={{
            bottom: {
              style: 'solid',
              width: 's1',
              color: 'grey400',
            },
          }}
          paddingBottom="s16"
          paddingTop="s16"
          gap="s16"
        >
          <Text.Normal weight="bold">{i18n.t('people_chart.employee_detail.contact_details')}</Text.Normal>
          <Box justifyContent="spaceBetween" flexDirection="row">
            <Box gap="s12">
              <Text.Normal weight="medium" size="100">
                {i18n.t('people_chart.employee_detail.email')}
              </Text.Normal>
              <Text.Normal weight="medium" size="100">
                {i18n.t('people_chart.employee_detail.phone')}
              </Text.Normal>
            </Box>
            <Box alignItems="flexEnd" gap="s12">
              <Text.Normal size="100" weight="semibold">
                {employee.email}
              </Text.Normal>
              <Text.Normal size="100" weight="semibold">
                {employee.phoneNumber}
              </Text.Normal>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default TeamsDetail
